import { tradePromoRule } from './tradePromoRule';
import { tradePromoAction } from './tradePromoAction';
import { expiringTradePromoRule } from './expiringTradePromoRule';
import { expiringTradePromoAction } from './expiringTradePromoAction';

export const tradePromosConfig = [
    {
        name: 'tradePromo',
        rule: tradePromoRule,
        action: tradePromoAction,
        priority: 440,
    },
    {
        name: 'expiringTradePromo',
        rule: expiringTradePromoRule,
        action: expiringTradePromoAction,
        priority: 445,
    },
];
